import { makeStyles, createStyles } from '../../styles';
import { textTruncate } from '../../mixins';
export default makeStyles((theme) => createStyles({
    root: {
        position: 'relative',
        width: '100%',
        height: 40,
        '&:before, &:after': {
            display: 'none',
        },
        '& $select': {
            paddingRight: theme.spacing(4),
        },
    },
    select: Object.assign(Object.assign({ width: '100%', height: '100%', boxSizing: 'border-box', padding: theme.spacing(0, 1.5), display: 'flex', alignItems: 'center', fontSize: theme.fontSizes.md, color: theme.input.foreground, backgroundColor: theme.palette.background.default, border: `1px solid ${theme.input.border}`, borderRadius: theme.borderRadius.sm, outline: 'none', appearance: 'none', fontWeight: 400, fontFamily: theme.typography.fontFamily }, textTruncate()), { '&:focus': {
            borderColor: theme.input.focusedBorder,
            borderRadius: theme.borderRadius.sm,
            backgroundColor: theme.palette.background.default,
        }, '&:disabled': {
            opacity: 0.5,
            cursor: 'not-allowed',
        } }),
    icon: {
        height: '100%',
        top: 0,
        right: theme.spacing(1.5),
    },
    iconDisabled: {
        opacity: 0.5,
    },
    menuPaper: {
        backgroundColor: '#fff',
        '& .MuiMenuItem-root': {
            fontFamily: 'inherit',
        },
    },
}));
//# sourceMappingURL=Select.styles.js.map